<template>
  <footer class="flex flex-col bg-[#e96932] text-[#f8f9fa] text-sm text-center rounded-t-[8px] mt-[20px] sm:mt-[40px] pt-[20px] pb-[15px]">
    <span class="text-base mb-[5px]">
      <a href="https://www.motornet.it/" target="_blank"><font-awesome-icon icon="fa-solid fa-address-card" title="Vai al sito web" class="h-[20px] mr-[8px]" />Sanguinetti Editore </a>
    </span>
    <span class="text-base mb-[5px]">
      <font-awesome-icon icon="fa-solid fa-credit-card" class="h-[20px] mr-[8px]" />P.Iva 0415607155
    </span>
    <span class="text-base">
      <a href="https://www.google.it/maps/place/Sanguinetti+Editore/@45.4660182,9.1893115,16.5z/data=!4m6!3m5!1s0x4786c6ae31e009d5:0x775a29cd680c3479!8m2!3d45.4666495!4d9.1926405!16s%2Fg%2F1ty734b0?entry=ttu" target="_blank">
        <font-awesome-icon icon="fa-solid fa-map-location-dot" title="Vedi sulla mappa" class="h-[20px] mr-[8px]" />Via Hoepli, 7 - 20121 Milano (MI)</a>
    </span>
  </footer>
</template>

<script>
export default {
  name: 'FooterView',
}
</script>